var map = {
	"./ion-action-sheet-controller_7.entry.js": [
		"1f61",
		"chunk-2d0b6cc6"
	],
	"./ion-action-sheet-ios.entry.js": [
		"659a",
		"chunk-1a202080"
	],
	"./ion-action-sheet-md.entry.js": [
		"ef71",
		"chunk-1a363574"
	],
	"./ion-alert-ios.entry.js": [
		"0359",
		"chunk-7da6e960"
	],
	"./ion-alert-md.entry.js": [
		"e19f",
		"chunk-7dbefa32"
	],
	"./ion-anchor_6.entry.js": [
		"1475",
		"chunk-3aa365a8"
	],
	"./ion-app_7-ios.entry.js": [
		"7b78",
		"chunk-397d7771"
	],
	"./ion-app_7-md.entry.js": [
		"cfeb",
		"chunk-39918c85"
	],
	"./ion-avatar_3-ios.entry.js": [
		"7f73",
		"chunk-1a214c64"
	],
	"./ion-avatar_3-md.entry.js": [
		"1ff3",
		"chunk-1a1e97db"
	],
	"./ion-back-button-ios.entry.js": [
		"43f7",
		"chunk-1a1f3589"
	],
	"./ion-back-button-md.entry.js": [
		"be4a",
		"chunk-1a34d469"
	],
	"./ion-backdrop-ios.entry.js": [
		"9a26",
		"chunk-5e6d8d53"
	],
	"./ion-backdrop-md.entry.js": [
		"1362",
		"chunk-5e693e25"
	],
	"./ion-button_2-ios.entry.js": [
		"bbb4",
		"chunk-39910897"
	],
	"./ion-button_2-md.entry.js": [
		"2ce3",
		"chunk-397b3ae4"
	],
	"./ion-card_5-ios.entry.js": [
		"578d",
		"chunk-1a1fb387"
	],
	"./ion-card_5-md.entry.js": [
		"2dd3",
		"chunk-1a1f047a"
	],
	"./ion-checkbox-ios.entry.js": [
		"7734",
		"chunk-397cd586"
	],
	"./ion-checkbox-md.entry.js": [
		"484a",
		"chunk-397b7c76"
	],
	"./ion-chip-ios.entry.js": [
		"a5d5",
		"chunk-1a33b17e"
	],
	"./ion-chip-md.entry.js": [
		"3874",
		"chunk-1a1ece3b"
	],
	"./ion-col_3.entry.js": [
		"d264",
		"chunk-2d21d882"
	],
	"./ion-datetime_3-ios.entry.js": [
		"8d91",
		"chunk-41881f52"
	],
	"./ion-datetime_3-md.entry.js": [
		"dd04",
		"chunk-416020d2"
	],
	"./ion-fab_3-ios.entry.js": [
		"7748",
		"chunk-1a209b9d"
	],
	"./ion-fab_3-md.entry.js": [
		"6ae6",
		"chunk-1a20cad5"
	],
	"./ion-img.entry.js": [
		"4633",
		"chunk-2d0c1558"
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"1ea0",
		"chunk-bd911bc2"
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"7526",
		"chunk-bd8d1b04"
	],
	"./ion-input-ios.entry.js": [
		"6a60",
		"chunk-397cff2a"
	],
	"./ion-input-md.entry.js": [
		"9111",
		"chunk-397da77d"
	],
	"./ion-item-option_3-ios.entry.js": [
		"ef10",
		"chunk-39926ec5"
	],
	"./ion-item-option_3-md.entry.js": [
		"ba59",
		"chunk-3990ff68"
	],
	"./ion-item_8-ios.entry.js": [
		"b665",
		"chunk-1a34240c"
	],
	"./ion-item_8-md.entry.js": [
		"1768",
		"chunk-1a1de1a1"
	],
	"./ion-loading-ios.entry.js": [
		"d773",
		"chunk-7dbe9be8"
	],
	"./ion-loading-md.entry.js": [
		"c500",
		"chunk-7dbe1f2b"
	],
	"./ion-menu_4-ios.entry.js": [
		"b1ab",
		"chunk-55832fba"
	],
	"./ion-menu_4-md.entry.js": [
		"3e30",
		"chunk-556e8fb9"
	],
	"./ion-modal-ios.entry.js": [
		"c9e1",
		"chunk-2418d746"
	],
	"./ion-modal-md.entry.js": [
		"fff0",
		"chunk-2414caf6"
	],
	"./ion-nav_4.entry.js": [
		"a2be",
		"chunk-30de1e9e"
	],
	"./ion-popover-ios.entry.js": [
		"1c07",
		"chunk-24451dd8"
	],
	"./ion-popover-md.entry.js": [
		"304d",
		"chunk-2444c9f0"
	],
	"./ion-progress-bar-ios.entry.js": [
		"ba1a",
		"chunk-3990ff14"
	],
	"./ion-progress-bar-md.entry.js": [
		"73fe",
		"chunk-397ccce0"
	],
	"./ion-radio_2-ios.entry.js": [
		"88c7",
		"chunk-397d5379"
	],
	"./ion-radio_2-md.entry.js": [
		"2e5b",
		"chunk-397b3cc5"
	],
	"./ion-range-ios.entry.js": [
		"da8e",
		"chunk-3991e8af"
	],
	"./ion-range-md.entry.js": [
		"a38a",
		"chunk-398fdee0"
	],
	"./ion-refresher_2-ios.entry.js": [
		"3d91",
		"chunk-bd8f5b76"
	],
	"./ion-refresher_2-md.entry.js": [
		"87b7",
		"chunk-bd8c17a0"
	],
	"./ion-reorder_2-ios.entry.js": [
		"e315",
		"chunk-d87d5354"
	],
	"./ion-reorder_2-md.entry.js": [
		"1b77",
		"chunk-d8ab3796"
	],
	"./ion-ripple-effect.entry.js": [
		"9994",
		"chunk-2d0e6731"
	],
	"./ion-searchbar-ios.entry.js": [
		"8691",
		"chunk-4268c39b"
	],
	"./ion-searchbar-md.entry.js": [
		"4705",
		"chunk-4266f4cd"
	],
	"./ion-segment_2-ios.entry.js": [
		"0e7c",
		"chunk-1a1e1a3a"
	],
	"./ion-segment_2-md.entry.js": [
		"1dd0",
		"chunk-1a1e9018"
	],
	"./ion-select_3-ios.entry.js": [
		"5c6e",
		"chunk-397c9282"
	],
	"./ion-select_3-md.entry.js": [
		"6cb2",
		"chunk-397d0c02"
	],
	"./ion-slide_2-ios.entry.js": [
		"6dea",
		"chunk-5d0c63b2"
	],
	"./ion-slide_2-md.entry.js": [
		"6ba2",
		"chunk-5d0c5b85"
	],
	"./ion-spinner.entry.js": [
		"b552",
		"chunk-1a342029"
	],
	"./ion-split-pane-ios.entry.js": [
		"8e68",
		"chunk-2d0e97a5"
	],
	"./ion-split-pane-md.entry.js": [
		"0baa",
		"chunk-2d0aeec8"
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"ec59",
		"chunk-1a3629fb"
	],
	"./ion-tab-bar_2-md.entry.js": [
		"edb4",
		"chunk-1a36332a"
	],
	"./ion-tab_2.entry.js": [
		"7914",
		"chunk-9c7ee6e4"
	],
	"./ion-text.entry.js": [
		"6770",
		"chunk-1a202793"
	],
	"./ion-textarea-ios.entry.js": [
		"da20",
		"chunk-3991e7c0"
	],
	"./ion-textarea-md.entry.js": [
		"c228",
		"chunk-3990c2fa"
	],
	"./ion-toast-ios.entry.js": [
		"2671",
		"chunk-7da7dd97"
	],
	"./ion-toast-md.entry.js": [
		"9076",
		"chunk-7daaf5af"
	],
	"./ion-toggle-ios.entry.js": [
		"2028",
		"chunk-418f1bd2"
	],
	"./ion-toggle-md.entry.js": [
		"bc51",
		"chunk-4161f8a0"
	],
	"./ion-virtual-scroll.entry.js": [
		"514e",
		"chunk-2d0c7743"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8b81";
module.exports = webpackAsyncContext;